import axios from '@/libs/api.request'
import axios1 from '@/libs/upload.request'

/**
 * 处理预览数据
 */
export const dealPreviewReport = (report_id, deal_type) => {
    const data ={
        "report_id": report_id,
        "deal_type": deal_type
    }
    return axios.request({
        url: '/api/admin/workreport/dealPreviewReport',
        data,
        method: 'post'
    })
}

/**
 * 接口导入作业报告
 */
export const interfaceWorkReport = (start_time, end_time) => {
    const data ={
        "start_time": start_time,
        "end_time": end_time
    }
    return axios.request({
        url: '/api/admin/workreport/interfaceReport',
        data,
        method: 'post'
    })
}

/**
 * 获取孔合并的报告列表
 */
export const holeReportList = (hole_id, report_type) => {
    const data ={
        "hole_id": hole_id,
        "report_type": report_type
    }
    return axios.request({
        url: '/api/admin/workreport/mergeList',
        data,
        method: 'post'
    })
}
/**
 * 获取孔合并的报告列表
 */
 export const mergeListForContrast = (hole_id, report_type, report_count_type) => {
    const data ={
        "hole_id": hole_id,
        "report_type": report_type,
        "report_count_type": report_count_type
    }
    return axios.request({
        url: '/api/admin/workreport/mergeListForContrast',
        data,
        method: 'post'
    })
}
/**
 * 获取孔合并的报告列表-检查孔
 */
export const holeReportListCheck = (hole_id, report_type) => {
    const data ={
        "hole_id": hole_id,
        "report_type": report_type
    }
    return axios.request({
        url: '/api/admin/workreport/mergeListCheck',
        data,
        method: 'post'
    })
}

/**
 * 报告详情合并
 */
export const mergeInfo = (report_type, hole_id, segment_no) => {
    const data ={
        "report_type": report_type,
        "hole_id": hole_id,
        "segment_no": segment_no
    }
    return axios.request({
        url: '/api/admin/workreport/mergeInfo',
        data,
        method: 'post'
    })
}

/**
 * 抽检报告导出PDF
 */
export const exportExtractReport = (hole_ids) => {
    const data ={
        "hole_ids": hole_ids,
    }
    return axios.request({
        url: '/api/admin/workreport/exportExtractReport',
        data,
        method: 'post'
    })
}

/**
 * 删除报告
 */
export const delReport = (report_id) => {
    const data ={
        "report_id": report_id,
    }
    return axios.request({
        url: '/api/admin/workreport/delReport',
        data,
        method: 'post'
    })
}

/**
 * OCR导入PDF报告
 */
 export const ocrRecognitionPDF = () => {
    const data ={

    }
    return axios.request({
        url: '/api/admin/workreportocr/ocrRecognitionPDF',
        data,
        method: 'post'
    })
}

/**
 * OCR导入扫描文件
 */
export const uploadBase64File = (blob, recognition_type) => {
    const formData = new FormData();
    formData.append('upFile', blob, 'filename.pdf');
    formData.append('recognition_type', recognition_type);
    return axios1.request({
        url: '/api/admin/workreportocr/uploadBase64File',
        data: formData,
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data; boundary=' + new Date().getTime()
        }
    })
}

/**
 * OCR保存报告
 */
 export const ocrSaveReport = (report_type, device_code, channel_no, begin_time, end_time, work_type, hole_code, segment_no, segment_length, segment_top, segment_bottom, pile_no, lift_hole_no, hole_height, order_index, water_ash, sand_ash, pressure_set, water_mud_proportion, sand_proportion, circle_type, water_pressure, groundwater_level, grout_volume, ash_volume, ash_volume_unit, sand_volume, grout_volume_throw, ash_volume_throw, piping_volume, piping_ash_volume, material1_total, material2_total, security_code, grout_duration, permeable_rate, construction_unit, monitor_unit, time_interval, list_str, filePath, fileName, deal_type, ocr_log_id, save_type) => {
    const data ={
        report_type: report_type,
        device_code: device_code,
        channel_no: channel_no,
        begin_time: begin_time,
        end_time: end_time,
        work_type: work_type,
        hole_code: hole_code,
        segment_no: segment_no,
        segment_length: segment_length,
        segment_top: segment_top,
        segment_bottom: segment_bottom,
        pile_no: pile_no,
        lift_hole_no: lift_hole_no,
        hole_height: hole_height,
        order_index: order_index,
        water_ash: water_ash,
        sand_ash: sand_ash,
        pressure_set: pressure_set,
        water_mud_proportion: water_mud_proportion,
        sand_proportion: sand_proportion,
        circle_type: circle_type,
        water_pressure: water_pressure,
        groundwater_level: groundwater_level,
        grout_volume: grout_volume,
        ash_volume: ash_volume,
        ash_volume_unit: ash_volume_unit,
        sand_volume: sand_volume,
        grout_volume_throw: grout_volume_throw,
        ash_volume_throw: ash_volume_throw,
        piping_volume: piping_volume,
        piping_ash_volume: piping_ash_volume,
        material1_total: material1_total,
        material2_total: material2_total,
        security_code: security_code,
        grout_duration: grout_duration,
        permeable_rate: permeable_rate,
        construction_unit: construction_unit,
        monitor_unit: monitor_unit,
        time_interval: time_interval,
        list_str: list_str,
        filePath: filePath,
        fileName: fileName,
        deal_type: deal_type,
        ocr_log_id: ocr_log_id,
        save_type: save_type
    }
    return axios.request({
        url: '/api/admin/workreportocr/ocrSaveReport',
        data,
        method: 'post'
    })
}

/**
 * OCR记录
 */
export const ocrInfo = (id) => {
    const data ={
        id: id
    }
    return axios.request({
        url: '/api/admin/ocrlog/info',
        data,
        method: 'post'
    })
}

/**
 * 导出作业报告Excel
 */
export const exportWorkReport = (id) => {
    const data ={
        id: id
    }
    return axios.request({
        url: '/api/admin/workreport/exportWorkReport',
        data,
        method: 'post'
    })
}

/**
 * 批量导出作业报告Excel
 */
 export const exportWorkReportBatch = (pid, start_date, end_date, work_type_int) => {
    const data ={
        pid: pid,
        start_date: start_date,
        end_date: end_date,
        work_type_int: work_type_int
    }
    return axios.request({
        url: '/api/admin/workreport/exportWorkReportBatch',
        data,
        method: 'post'
    })
}

/**
 * 批量导出作业报告Excel
 */
 export const checkExportWorkReportBatchCompleted = (folder) => {
    const data ={
        folder: folder
    }
    return axios.request({
        url: '/api/admin/workreport/checkExportWorkReportBatchCompleted',
        data,
        method: 'post'
    })
}

/**
 * 更新备注
 */
 export const updateReportRemark = (report_id, remark) => {
    const data ={
        report_id: report_id,
        remark: remark
    }
    return axios.request({
        url: '/api/admin/workreport/updateRemark',
        data,
        method: 'post'
    })
}